export default {
  homepage: {
    topDealsTag: "b75fdbb6-1af9-42eb-8b44-622039e6e9af",
    topDeals: "Die Topdeals des Tages",
    currentDealsTitle: "Aktuelle Deals",
    currentDealsSubline:
      "Hier findet ihr alle verfügbaren Deals auf einen Blick",
    buttonText: "Zu den Deals",

    tagSection_1_tagImage: "/assets/images/home-mood/destination_austria",
    tagSection_1_tagId: "a4c519b0-8ed4-4e42-b673-85a15e3533e4",
    tagSection_1_title: "Österreich Liebe",
    tagSection_1_subline:
      "Gute und preiswerte Angebote für Urlaub in Österreich",

    tagSection_2_tagImage: "/assets/images/home-mood/tag_flexcancel",
    tagSection_2_tagId: "a6454932-56bc-45fb-9dfd-e916f082ce14",
    tagSection_2_title: "Pauschalreisen",
    tagSection_2_subline: "Hier findet Ihr die besten Pauschalreisen.",

    tagSection_3_tagImage: "/assets/images/home-mood/tag_hotelvouchers",
    tagSection_3_tagId: "102e0652-135d-460b-af9b-bc1d9c2185ca",
    tagSection_3_title: "Hotelgutscheine",
    tagSection_3_subline: "Heute kaufen, flexibel reisen",

    promotionSection_link: "https://urlaubsguru.at/adventskalender-2020",
    promotionSection_title: "Der große Adventskalender",
    promotionSection_subline:
      "Mitmachen und täglich eine von 24 Reisen gewinnen!",

    partnerSection_link:
      "https://buchen.urlaubsguru.at/region?dur=7&ibe=hotel&ddate=2018-08-15&rdate=2018-09-29&adult=2&_ga=2.178471271.252352868.1598601230-2100991080.1590410166&agent=blog;Urlaubsguru;fb;socialorganic;1078252;/suchen-und-buchen/;desktop;",
    partnerSection_title: "Hotelsuche",
    partnerSection_subline: "Unterkünfte, wie ihr sie braucht",
    noMoreDealsInfo: "keine weiteren Angebote vorhanden"
  },
  supportPersonImageSrc: "/assets/images/callcenter/lena.jpg",

  magazine: {
    section: {
      link: "https://www.urlaubsguru.at/reisemagazin/",
      image: "/assets/images/magazine/at.jpg"
    }
  },

  raffle: {
    link: "https://www.urlaubsguru.at/kreta-ostergewinnspiel/"
  },

  partnerList: {
    headline: "Weitere Reisearten",
    subline: "Urlaub, wie ihr ihn braucht",
    data: [
      {
        label: "Hotels",
        sub: "Die perfekte Unterkunft",
        url: "https://buchen.urlaubsguru.at/region?dur=7&ibe=hotel&ddate=2018-08-15&rdate=2018-09-29&adult=2&_ga=2.178471271.252352868.1598601230-2100991080.1590410166&agent=blog;Urlaubsguru;fb;socialorganic;1078252;/suchen-und-buchen/;desktop;",
        image: "/assets/images/teasercards/Kachel_WL_368x180_hotels.png"
      },
      {
        label: "Flüge",
        sub: "Günstige Flüge weltweit",
        url: "https://www.urlaubsguru.at/flugsuche/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_fluege.png"
      },
      {
        label: "Kurzreisen",
        sub: "Kurz mal weg mit Wellness, Events & mehr",
        url: "https://kurzreisen.urlaubsguru.at/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_kurzreisen.png"
      },
      {
        label: "Hotelgutscheine",
        sub: "Heute kaufen, flexibel reisen",
        url: "https://urlaubsguru.urlaubsgutschein.kaufen/",
        image:
          "/assets/images/teasercards/Kachel_WL_368x180_hotelgutscheine.png"
      },
      {
        label: "Last Minute",
        sub: "Last Minute Angebote zum kleinen Preis",
        url: "https://www.urlaubsguru.at/last-minute-angebote/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_fruehbucher.png"
      },
      {
        label: "Städtereisen",
        sub: "Citytrips mit Flug & Hotel",
        url: "https://staedtereisen.urlaubsguru.at/de-at/galerie",
        image: "/assets/images/teasercards/Kachel_WL_368x180_staedtereisen.png"
      },
      {
        label: "Skireisen",
        sub: "Skiurlaub - preiswert wie nie zuvor",
        url: "https://skireisen.urlaubsguru.at/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_skireisen.png"
      },
      {
        label: "Mietwagen",
        sub: "Preiswerte Mietwagen im Vergleich",
        url: "https://www.urlaubsguru.at/mietwagen/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_mietwagen.png"
      },
      {
        label: "Kreuzfahrten",
        sub: "Günstige Kreuzfahrten im Vergleich",
        url: "https://kreuzfahrten.urlaubsguru.at/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_kreuzfahrten.png"
      },
      {
        label: "Pauschalreisen",
        sub: "Reisen mit allem was dazu gehört",
        url: "https://buchen.urlaubsguru.at/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_pauschalreisen.png"
      },
      {
        label: "Reiseanfrage",
        sub: "Stellt jetzt eure individuelle Reiseanfrage",
        url: "https://www.urlaubsguru.at/individuelle-reiseanfrage/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_reiseanfragen.png"
      }
    ]
  },

  linkList: [
    {
      label: "Beliebte Urlaubsziele",
      links: [
        {
          label: "Griechenland Urlaub",
          url: "https://www.urlaubsguru.at/urlaubsziele/griechenland/"
        },
        {
          label: "Kanaren Urlaub",
          url: "https://www.urlaubsguru.at/urlaubsziele/kanaren/"
        },
        {
          label: "Kroatien Urlaub",
          url: "https://www.urlaubsguru.at/urlaubsziele/kroatien/"
        },
        {
          label: "Italien Urlaub",
          url: "https://www.urlaubsguru.at/urlaubsziele/italien-urlaub/"
        },
        {
          label: "Spanien Urlaub",
          url: "https://www.urlaubsguru.at/urlaubsziele/spanien/"
        },
        {
          label: "Österreich Urlaub",
          url: "https://www.urlaubsguru.at/oesterreichliebe/"
        }
      ]
    },
    {
      label: "Urlaubsziele weltweit",
      links: [
        {
          label: "Ägypten Urlaub",
          url: "https://www.urlaubsguru.at/urlaubsziele/aegypten-urlaub/"
        },
        {
          label: "Dubai Urlaub",
          url: "https://www.urlaubsguru.at/tag/dubai/"
        },
        {
          label: "Türkei Urlaub",
          url: "https://www.urlaubsguru.at/urlaubsziele/tuerkei-urlaub/"
        },
        {
          label: "Thailand Urlaub",
          url: "https://www.urlaubsguru.at/tag/thailand/"
        },
        {
          label: "DomRep Urlaub",
          url: "https://www.urlaubsguru.at/tag/dominikanische-republik/"
        },
        {
          label: "Malediven Urlaub",
          url: "https://www.urlaubsguru.at/tag/malediven/"
        },
        {
          label: "Hurghada Urlaub",
          url: "https://www.urlaubsguru.at/tag/hurghada/"
        }
      ]
    },
    {
      label: "Reisearten",
      links: [
        {
          label: "Pauschalreisen",
          url: "https://www.urlaubsguru.at/tag/pauschalreise/"
        },
        {
          label: "All Inclusive",
          url: "https://www.urlaubsguru.at/tag/all-inclusive/"
        },
        {
          label: "Städtetrip",
          url: "https://www.urlaubsguru.at/tag/staedtetrip/"
        },
        {
          label: "Luxusurlaub",
          url: "https://www.urlaubsguru.at/tag/luxus/"
        },
        {
          label: "Kurztrip",
          url: "https://www.urlaubsguru.at/tag/kurztrip/"
        },
        {
          label: "Familienurlaub",
          url: "https://www.urlaubsguru.at/tag/familienurlaub/"
        },
        {
          label: "Singlereisen",
          url: "https://www.urlaubsguru.at/singlereisen/"
        }
      ]
    },
    {
      label: "Wellnessurlaub",
      links: [
        {
          label: "Wellness",
          url: "https://www.urlaubsguru.at/tag/wellness/"
        },
        {
          label: "Wellness in Österreich",
          url: "https://www.urlaubsguru.at/tag/wellness/"
        },
        {
          label: "Wellness in Loipersdorf",
          url: "https://www.urlaubsguru.at/freizeitaktivitaeten/therme-loipersdorf/"
        },
        {
          label: "Wellness in Tirol",
          url: "https://www.urlaubsguru.at/tag/wellness-in-tirol/"
        },
        {
          label: "Wellnesshotel",
          url: "https://www.urlaubsguru.at/tag/wellnesshotel/"
        },
        {
          label: "Thermenangebote",
          url: "https://www.urlaubsguru.at/tag/thermen-angebote/"
        }
      ]
    },
    {
      label: "Städtereisen",
      links: [
        {
          label: "Städtereisen",
          url: "https://www.urlaubsguru.at/tag/staedtereise/"
        },
        {
          label: "Städtereise London",
          url: "https://www.urlaubsguru.at/tag/london/"
        },
        {
          label: "Städtereise New York",
          url: "https://www.urlaubsguru.at/tag/new-york/"
        },
        {
          label: "Städtereise Paris",
          url: "https://www.urlaubsguru.at/tag/paris/"
        },
        {
          label: "Städtereise Wien",
          url: "https://www.urlaubsguru.at/tag/wien/"
        },
        {
          label: "Städtereise Amsterdam",
          url: "https://www.urlaubsguru.at/tag/amsterdam/"
        },
        {
          label: "Städtereise Berlin",
          url: "https://www.urlaubsguru.at/tag/berlin/"
        }
      ]
    },
    {
      label: "Last Minute",
      links: [
        {
          label: "Last Minute",
          url: "https://www.urlaubsguru.at/last-minute/"
        },
        {
          label: "Last Minute Ägypten",
          url: "https://www.urlaubsguru.at/last-minute-aegypten/"
        },
        {
          label: "Last Minute Dubai",
          url: "https://www.urlaubsguru.at/last-minute-dubai/"
        },
        {
          label: "Last Minute Griechenland",
          url: "https://www.urlaubsguru.at/last-minute-griechenland/"
        },
        {
          label: "Last Minute Mallorca",
          url: "https://www.urlaubsguru.at/last-minute-mallorca/"
        },
        {
          label: "Last Minute Türkei",
          url: "https://www.urlaubsguru.at/last-minute-tuerkei/"
        }
      ]
    },
    {
      label: "Specials",
      links: [
        {
          label: "Flexibel stornierbare Angebote",
          url: "https://www.urlaubsguru.at/reiseangebote-kostenfrei-stornierbar/"
        },
        {
          label: "Fenstertage Angebote",
          url: "https://www.urlaubsguru.at/reisekalender/fenstertage/"
        },
        {
          label: "Skiurlaub",
          url: "https://www.urlaubsguru.at/tag/skiurlaub/"
        },
        {
          label: "Hotelgutscheine",
          url: "https://www.urlaubsguru.at/tag/hotelgutschein/"
        },
        {
          label: "Freizeitpark Angebote",
          url: "https://www.urlaubsguru.at/tag/freizeitpark-deals/"
        },
        {
          label: "Aktivitäten & mehr",
          url: "https://www.urlaubsguru.at/tag/aktivitaeten-mehr/"
        }
      ]
    },
    {
      label: "Informationen",
      links: [
        {
          label: "Reisemagazin",
          url: "https://www.urlaubsguru.at/reisemagazin/"
        },
        {
          label: "Reisekalender",
          url: "https://www.urlaubsguru.at/reisekalender/"
        },
        {
          label: "Beste Reisezeit",
          url: "https://www.urlaubsguru.at/reisekalender/beste-reisezeit/"
        },
        {
          label: "Freizeitaktivitäten",
          url: "https://www.urlaubsguru.at/freizeitaktivitaeten/"
        },
        {
          label: "Lexikon",
          url: "https://www.urlaubsguru.at/lexikon/"
        }
      ]
    }
  ],

  footer: {
    corporate: {
      label: "Unternehmen",
      data: [
        {
          label: "Über Urlaubsguru",
          url: "https://www.urlaubsguru.at/ueber-uns/"
        },
        {
          label: "Jobs",
          url: "https://www.urlaubsguru.de/jobs/"
        },
        {
          label: "Werbung",
          url: "https://www.urlaubsguru.at/werbung-und-kooperationen/"
        },
        {
          label: "Presse",
          url: "https://www.urlaubsguru.de/presse/"
        }
      ]
    },
    informations: {
      label: "Informationen",
      data: [
        {
          label: "Corona Infos",
          url: "https://www.urlaubsguru.at/corona/"
        },
        {
          label: "Buchen beim Urlaubsguru",
          url: "https://www.urlaubsguru.at/suchen-buchen-urlaubsguru/"
        },
        {
          label: "Dein Feedback an Uns",
          url: "https://www.urlaubsguru.at/urlaubsguru-feedback/"
        },
        {
          label: "Reisemagazin",
          url: "https://www.urlaubsguru.at/reisemagazin/"
        }
      ]
    },
    buttons: [
      {
        label: "Datenschutz",
        url: "https://www.urlaubsguru.at/datenschutzerklaerung/"
      },
      {
        label: "Sitemap",
        url: "https://www.urlaubsguru.at/sitemap/"
      },
      {
        label: "Schlagworte",
        url: "https://www.urlaubsguru.at/tag/"
      },
      {
        label: "Impressum / Rechtliche Hinweise",
        url: "https://www.urlaubsguru.at/impressum/"
      }
    ],
    social: {
      label: "Folgt uns auf",
      data: [
        {
          label: "Facebook",
          icon: "facebook",
          url: "https://www.facebook.com/urlaubsguruAT/"
        },
        {
          label: "Instagram",
          icon: "instagram",
          url: "https://www.instagram.com/urlaubsguru_at/"
        }
      ]
    },
    newsletter: {
      label: "Meldet euch für den Newsletter an",
      button: "Zum Newsletter",
      url: "https://www.urlaubsguru.at/messenger/"
    },
    app: {
      label: "Ladet euch die App herunter",
      apple:
        "https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087",
      android: "https://play.google.com/store/apps/details"
    }
  },
  skiSearchControls: {
    durationOptions: [
      {
        name: "exakt wie angegeben",
        value: "exact"
      },
      {
        name: "beliebig",
        value: "any"
      },
      {
        name: "7 Nächte",
        value: "7,7"
      },
      {
        name: "1-2 Nächte",
        value: "1,2"
      },
      {
        name: "2-5 Nächte",
        value: "2,5"
      },
      {
        name: "5-9 Nächte",
        value: "5,9"
      },
      {
        name: "9-11 Nächte",
        value: "9,11"
      },
      {
        name: "1 Nacht",
        value: "1,1"
      },
      {
        name: "2 Nächte",
        value: "2,2"
      },
      {
        name: "3 Nächte",
        value: "3,3"
      },
      {
        name: "4 Nächte",
        value: "4,4"
      },
      {
        name: "5 Nächte",
        value: "5,5"
      },
      {
        name: "6 Nächte",
        value: "6,6"
      },
      {
        name: "7 Nächte",
        value: "7,7"
      },
      {
        name: "8 Nächte",
        value: "8,8"
      },
      {
        name: "9 Nächte",
        value: "9,9"
      },
      {
        name: "10 Nächte",
        value: "10,10"
      },
      {
        name: "11 Nächte",
        value: "11,11"
      }
    ]
  },

  ibeSearchControls: {
    dayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    monthNames: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    durationOptions: [
      {
        name: "exakt wie angegeben",
        value: "exact"
      },
      {
        name: "beliebig",
        value: ""
      },
      {
        name: "1 - 4 Tage",
        value: "1,4"
      },
      {
        name: "5 - 8 Tage",
        value: "5,8"
      },
      {
        name: "9 - 12 Tage",
        value: "9,12"
      },
      {
        name: "10  Tage",
        value: "10"
      },
      {
        name: "1 Wochenende",
        value: "2"
      },
      {
        name: "1 Woche",
        value: "7"
      },
      {
        name: "2 Wochen",
        value: "14"
      }
    ],
    childAgeOptions: [
      { label: "< 2 Jahre", value: 1 },
      { label: "2 Jahre", value: 2 },
      { label: "3 Jahre", value: 3 },
      { label: "4 Jahre", value: 4 },
      { label: "5 Jahre", value: 5 },
      { label: "6 Jahre", value: 6 },
      { label: "7 Jahre", value: 7 },
      { label: "8 Jahre", value: 8 },
      { label: "9 Jahre", value: 9 },
      { label: "10 Jahre", value: 10 },
      { label: "11 Jahre", value: 11 },
      { label: "12 Jahre", value: 12 },
      { label: "13 Jahre", value: 13 },
      { label: "14 Jahre", value: 14 },
      { label: "15 Jahre", value: 15 },
      { label: "16 Jahre", value: 16 },
      { label: "17 Jahre", value: 17 }
    ]
  },
  jsonLD: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Urlaubsguru",
    url: "https://www.urlaubsguru.at/",
    logo: "https://www.urlaubsguru.at/wp-content/uploads/2016/04/logo_urlaubsguru_277x60.png",
    sameAs: [
      "https://www.facebook.com/urlaubsguruAT/",
      "https://www.instagram.com/urlaubsguru_at/"
    ]
  },
  searchCustomLinks: [
    {
      label: "Kurzreisen",
      url: "https://kurzreisen.urlaubsguru.at/getaways/",
      icon: "deck-chair-sun"
    }
  ],
  privacyManagerModalId: "547837",
  destination_category_destination: "Regionen",
  destination_category_region: "Regionen",
  destination_category_accommodation: "Hotels",
  destination_category_city: "Städte",
  destination_category_poi: "Sehenswürdigkeiten",
  destination_category_point_of_interest: "Sehenswürdigkeiten",
  destination_category_multi_city_vicinity: "Gebiete",
  destination_category_province_state: "Regionen",
  destination_category_neighborhood: "Umgebungen",
  destination_category_airport: "Flughäfen",
  destination_category_train_station: "Bahnstationen",
  destination_category_metro_station: "Metrostationen",
  destination_category_continent: "Kontinente",
  destination_category_country: "Länder",
  destination_category_high_level_region: "Gebiete",

  newsletter: {
    title: "Dein Urlaubsguru-Newsletter",
    info: "Du suchst nach <strong>hilfreichen Reiseempfehlungen und Top Deals?</strong> Dann melde dich für den exklusiven Urlaubsguru Newsletter an. <br /> <br />Das erwartet dich:",
    listItem1: "handverlesene Angebote von den Urlaubsguru-Reiseexperten",
    listItem2: "Deals mit unschlagbarem Preisleistungsverhältnis",
    listItem3: "Inspiration und hilfreiche Tipps für deine nächste Reise",
    button: "Newsletter anmelden"
  },
  amadeusPackageTourSearch: {
    infoTextSingleRoom: "Alle Personen werden in einem Zimmer untergebracht. Wünscht ihr eine andere Zimmeraufteilung, ruft uns an:"
  }
}
